import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { getAllOrgan } from '@/services/form.js';
import { getUser } from '@/services/system.js';
import { TreeSelect } from 'ant-design-vue';
// import selectPerson from '@/components/select-person';
import selectPerson from '@/components/select-person/genera';
var SHOW_PARENT = TreeSelect.SHOW_PARENT;
export default {
  components: {
    selectPerson: selectPerson
  },
  name: 'FormConfig',
  props: {
    formConfig: Object
  },
  data: function data() {
    var userGroupTabList = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }, {
      title: '岗位',
      value: 4
    }, {
      title: '岗位成员',
      value: 5
    }];
    var organInfo = [{
      title: '组织',
      value: 0
    }, {
      title: '组织成员',
      value: 1
    }, {
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return {
      SHOW_PARENT: SHOW_PARENT,
      userGroupTabList: userGroupTabList,
      organInfo: organInfo,
      current: '1',
      form: {
        fillType: 1,
        typeId: [],
        treeSelectValue: [],
        selectValue: undefined,
        treeData: [],
        userData: []
      },
      formManager: {
        fillType: 1,
        typeId: [],
        treeSelectValue: [],
        selectValue: undefined,
        treeData: [],
        userData: []
      },
      useOrganDataList: [{
        type: 1,
        organId: 123456
      }],
      manageOrganDataList: [{
        type: 1,
        organId: 123456
      }],
      //---通用组件---
      userGroupList1: {
        postData: [],
        userData: [],
        organData: []
      },
      //使用范围
      userGroupList2: {
        postData: [],
        userData: [],
        organData: []
      },
      //管理范围
      radioValue: '0',
      //任务分配
      anyval: ''
    };
  },
  watch: {
    formConfig: {
      handler: function handler(newVal, oldVal) {}
    },
    'form.treeSelectValue': {
      handler: function handler(newVal, oldVal) {
        this.handleTreeSelectValue(newVal);
      },
      immediate: true
    },
    'formManager.treeSelectValue': {
      handler: function handler(newVal, oldVal) {
        this.handleTreeSelectValueManager(newVal);
      },
      immediate: true
    }
  },
  methods: {
    onTaskAssignmentChange: function onTaskAssignmentChange(e) {
      this.radioValue = e.target.value;
    },
    getOrganAll: function getOrganAll() {
      var _this = this;
      getAllOrgan().then(function (res) {
        if (res.data.code == 200) {
          _this.form.treeData = res.data.data;
          _this.formManager.treeData = res.data.data;
        }
      });
    },
    treeSelectOnSelect: function treeSelectOnSelect(value, node, extra) {
      this.useOrganDataList.push({
        type: node.dataRef.type,
        organId: value
      });
    },
    manageTreeSelectOnSelect: function manageTreeSelectOnSelect(value, node, extra) {
      this.manageOrganDataList.push({
        type: node.dataRef.type,
        organId: value
      });
    },
    handleTreeSelectValue: function handleTreeSelectValue(val) {
      var _this2 = this;
      var that = this;
      that.$nextTick(function () {
        _this2.useOrganDataList = _this2.useOrganDataList.filter(function (item) {
          return that.form.treeSelectValue.includes(item.organId);
        });
      });
    },
    handleTreeSelectValueManager: function handleTreeSelectValueManager(val) {
      var _this3 = this;
      var that = this;
      that.$nextTick(function () {
        _this3.manageOrganDataList = _this3.manageOrganDataList.filter(function (item) {
          return that.formManager.treeSelectValue.includes(item.organId);
        });
      });
    },
    selectOnSelect: function selectOnSelect(val) {},
    handleClick: function handleClick(e) {
      this.current = e.key;
    },
    radioGroup: function radioGroup(e) {},
    selectChange: function selectChange(e) {
      var form = e == 1 ? this.form : this.formManager;
      if (form.userData.length == 0) {
        getUser().then(function (res) {
          form.userData = res.data.data;
        });
      }
    },
    loadUsers: function loadUsers() {
      var _this4 = this;
      getUser().then(function (res) {
        _this4.form.userData = res.data.data;
        _this4.formManager.userData = res.data.data;
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var manageScopes, useScopes, radioValue;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return _this5.getOrganAll();
          case 1:
            _context.n = 2;
            return _this5.loadUsers();
          case 2:
            //-------同用组件------
            manageScopes = _this5.formConfig.manageScopes;
            useScopes = _this5.formConfig.useScopes;
            radioValue = _this5.formConfig.radioVlues;
            _this5.radioValue = radioValue || "0";
            if (manageScopes && manageScopes.length > 0) {
              manageScopes.forEach(function (item) {
                if ([0].indexOf(item.tabType) > -1) {
                  //组织
                  var organData = {
                    actorId: item.organId,
                    actorName: item.organName,
                    typeId: item.typeId,
                    tabType: item.tabType
                  };
                  _this5.userGroupList2.organData.push(organData);
                }
                if ([2, 4].indexOf(item.tabType) > -1) {
                  //组织岗位、岗位
                  var postDta = {
                    actorId: item.postId,
                    actorName: item.postName,
                    organId: item.organId == 0 ? undefined : item.organId,
                    organName: item.organName,
                    typeId: item.typeId == 0 ? undefined : item.typeId,
                    tabType: item.tabType
                  };
                  _this5.userGroupList2.postData.push(postDta);
                }
                if ([1, 3, 5].indexOf(item.tabType) > -1) {
                  //组织成员、组织岗位成员、岗位成员
                  var userDta = {
                    actorId: item.userId,
                    actorName: item.userName,
                    organId: item.organId ? undefined : item.organId,
                    postId: item.postId == 0 ? undefined : item.postId,
                    typeId: item.typeId == 0 ? undefined : item.typeId,
                    tabType: item.tabType
                  };
                  _this5.userGroupList2.userData.push(userDta);
                }
              });
            }
            if (useScopes && useScopes.length > 0) {
              useScopes.forEach(function (item) {
                if ([0].indexOf(item.tabType) > -1) {
                  //组织
                  var organData = {
                    actorId: item.organId,
                    actorName: item.organName,
                    typeId: item.typeId,
                    tabType: item.tabType
                  };
                  _this5.userGroupList1.organData.push(organData);
                }
                if ([2, 4].indexOf(item.tabType) > -1) {
                  //组织岗位、岗位
                  var postDta = {
                    actorId: item.postId,
                    actorName: item.postName,
                    organId: item.organId == 0 ? undefined : item.organId,
                    organName: item.organName,
                    typeId: item.typeId == 0 ? undefined : item.typeId,
                    tabType: item.tabType
                  };
                  _this5.userGroupList1.postData.push(postDta);
                }
                if ([1, 3, 5].indexOf(item.tabType) > -1) {
                  //组织成员、组织岗位成员、岗位成员
                  var userDta = {
                    actorId: item.userId,
                    actorName: item.userName,
                    organId: item.organId == 0 ? undefined : item.organId,
                    postId: item.postId == 0 ? undefined : item.postId,
                    typeId: item.typeId == 0 ? undefined : item.typeId,
                    tabType: item.tabType
                  };
                  _this5.userGroupList1.userData.push(userDta);
                }
              });
            }

            //     tabType: 1
            // formId: 5
            // organId: 30003
            // typeId: 3
            // userId: 0
            /*if (this.formConfig != undefined) {
                if (Object.keys(this.formConfig.useScopes).length > 0) {
                    this.form.tabType = this.formConfig.useScopes[0].tabType;
                    if (this.form.tabType == 1) {
                        this.form.treeSelectValue = this.formConfig.useScopes.map(item => item.organId);
                        this.useOrganDataList = this.formConfig.useScopes.map(item => {
                            return { organId: item.organId, type: item.typeId };
                        });
                    } else {
                        this.form.selectValue = this.formConfig.useScopes.map(item => item.userId);
                    }
                }
                if (Object.keys(this.formConfig.manageScopes).length > 0) {
                    this.formManager.tabType = this.formConfig.manageScopes[0].tabType;
                    if (this.formManager.tabType == 1) {
                        this.formManager.treeSelectValue = this.formConfig.manageScopes.map(
                            item => item.organId
                        );
                        this.useOrganDataList = this.formConfig.manageScopes.map(item => {
                            return { organId: item.organId, type: item.typeId };
                        });
                    } else {
                        this.formManager.selectValue = this.formConfig.manageScopes.map(
                            item => item.userId
                        );
                    }
                }
            }*/
          case 3:
            return _context.a(2);
        }
      }, _callee);
    }))();
  }
};